import { Fragment, h } from '@stencil/core';
import { EnvironmentTableRow } from './environment-table-row';
export const EnvironmentSubgroup = (subGroup) => {
  const { name, characteristicRecords, groupIcon } = subGroup || {};
  if (!characteristicRecords.length)
    return null;
  return h(Fragment, null, h("div", { class: "envsection_row envsection_subgroup-row" }, h("div", { class: "envsection_cell envsection_subgroup-name" }, h("pes-custom-qds-icon", { iconName: groupIcon, customClasses: 'envsection_subgroup-name-icon' }), name)), characteristicRecords === null || characteristicRecords === void 0 ? void 0 :
    characteristicRecords.map((record) => h(EnvironmentTableRow, Object.assign({}, record))));
};
